<template>
	<section>
		<!-- 添加规格弹出框 -->
		<el-dialog
			:title="$t('addSpecification.addSpecs')"
			:visible.sync="addDialogFormVisible"
			width="30%"
			:close-on-click-modal="false"
			:before-close="handleAddCancel"
		>
			<el-form ref="addDialogForm" :rules="formRules" :model="addDialogForm">
				<el-form-item :label="$t('addSpecification.specificationName')" prop="name">
					<el-input v-model="addDialogForm.name" :placeholder="$t('addSpecification.enterSpecificationName')" clearable></el-input>
				</el-form-item>
				<el-form-item :label="$t('addSpecification.attributes')" prop="options">
					<div class="table-caption">
						<el-button size="mini" type="primary" @click="handleAddOptions()">{{ $t("addSpecification.addTo") }}</el-button>
					</div>
					<el-table style="width: 100%" :data="this.addDialogForm.options" :empty-text="$t('addSpecification.addAttributes')" size="mini">
						<el-table-column prop="name" :title="$t('addSpecification.name')"> </el-table-column>
						<el-table-column prop="actions" :title="$t('addSpecification.operate')">
							<template slot-scope="scope">
								<el-button size="mini" type="danger" @click="handleDeleteOptions(scope.$index)">{{ $t("addSpecification.delete") }}</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button @click="handleAddCancel()">{{ $t("common.cancel") }}</el-button>
				<el-button type="primary" @click="handleAddConfirm()">{{ $t("common.sure") }}</el-button>
			</span>
		</el-dialog>

		<!-- 添加规格options弹出框 -->
		<el-dialog :title="$t('addSpecification.addProperties')" :visible.sync="addOptionsFormVisible" width="30%" :close-on-click-modal="false">
			<p>{{ $t("addSpecification.name") }}</p>
			<el-input v-model="optionsName" :placeholder="$t('addSpecification.enterSpecificationName')" clearable></el-input>
			<span slot="footer">
				<el-button @click="handleAddOptionsCancel()">{{ $t("common.cancel") }}</el-button>
				<el-button type="primary" @click="handleAddOptionsConfirm()">{{ $t("common.sure") }}</el-button>
			</span>
		</el-dialog>
	</section>
</template>
<script>
import { postCustomerAttributes } from "@/services/api-v2/api-v2";
export default {
	props: {
		// 添加规格弹出框
		addDialogFormVisible: {
			type: Boolean,
			required: true,
			default: false,
		},
	},
	data() {
		return {
			// 添加规格表单值
			addDialogForm: {
				name: "",
				options: [],
			},

			// 规格表单验证
			formRules: {
				name: [{ required: true, message: this.$t("addSpecification.enterSpecificationName"), trigger: "blur" }],
				options: [{ required: true, message: this.$t("addSpecification.addOptions"), trigger: "blur" }],
			},

			// 添加规格options弹出框
			addOptionsFormVisible: false,

			// 添加规格options名称
			optionsName: "",
		};
	},
	methods: {
		// 取消添加
		handleAddCancel() {
			this.$refs.addDialogForm.resetFields(); // 重置表单
			this.$emit("handle-add-cancel");
		},

		// 添加options弹出框
		handleAddOptions() {
			this.addOptionsFormVisible = true;
		},

		// 取消添加options
		handleAddOptionsCancel() {
			this.optionsName = "";
			this.addOptionsFormVisible = false;
		},

		// 删除options
		handleDeleteOptions(index) {
			this.addDialogForm.options.splice(index, 1);
		},

		// 确定添加options
		handleAddOptionsConfirm() {
			if (!this.optionsName) {
				this.$message.error(this.$t("addSpecification.enterAttributeName"));
				return;
			}
			this.addDialogForm.options.push({ name: this.optionsName });
			this.optionsName = "";
			this.addOptionsFormVisible = false;
		},

		// 确定添加
		async handleAddConfirm() {
			this.$refs.addDialogForm.validate(async (valid) => {
				if (valid) {
					try {
						await postCustomerAttributes(this.$route.params.id, this.addDialogForm);
						this.handleAddCancel();
						this.$emit("handle-update-specification");
						this.$message.success(this.$t("addSpecification.addedSuccessfully")); // 弹出成功提示
					} catch (error) {
						this.$message.error(error); // 弹出错误提示
					}
				} else {
					this.$message.error(this.$t("addSpecification.errorMessage"));
					return false;
				}
			});
		},
	},
};
</script>

<style scoped>
.table-caption {
	display: flex;
	justify-content: flex-end;
	padding-top: 5px;
}
</style>
